module.exports = __webpack_public_path__ + "static/media/sub-card-label-1.805c1ece.svg";